module.exports = __webpack_public_path__ + "media/svg-new/acessar-conteudo-blue-aa9e676a.svg";